/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_No_Matching_FilesInputs */

const en_files_no_matching_files = /** @type {(inputs: Files_No_Matching_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files match your search.`)
};

const es_files_no_matching_files = /** @type {(inputs: Files_No_Matching_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún archivo coincide con tu búsqueda.`)
};

/**
* | output |
* | --- |
* | "No files match your search." |
*
* @param {Files_No_Matching_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_no_matching_files = /** @type {((inputs?: Files_No_Matching_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_No_Matching_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_no_matching_files(inputs)
	return en_files_no_matching_files(inputs)
});